export const config = {
  serverURL: "https://api-nxtqa2.apps.mktnxt.com/api/v1.0",
  NXTServerURL: "https://{tenant}.mediascape-nxtqa2.apps.mktnxt.com",
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "nxtqa2",
  clientId: "2d7krjh4ip3k4jhq2bqksko9en",
  cognitoDomain: "duplo-nonprod.auth.us-east-1.amazoncognito.com",
  identityProvider: "duplo-nonprod",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-qa4.mediascape-dev.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_aCLCffalK",
};
